// removed by extract-text-webpack-plugin
module.exports = {"campaignEnterMobileInputContainer":"campaignEnterMobileInputContainer__1bpml","campaignEnterInputBoxMobile":"campaignEnterInputBoxMobile__2BDxX","campaignEnterMobileSubmitButton":"campaignEnterMobileSubmitButton__z4fHM","mobileNoPrefix":"mobileNoPrefix__3pZs5"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-activation/components/enterMobileSectionComponent/campaignEnterMobileInput/style.css
// module id = OE68
// module chunks = 380